import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getCategory(params) {
	return client.get("category/data", {
		params: params,
	});
}

export default {
	getCategory
};